const routes = [
  {
    path: '/share',
    name: 'share',
    component: () => import('@/views/share/share.vue'),
  },
  {
    path: '/:domain',
    component: () => import('@/views/agent/agent.vue'),
  },
]

export default routes
